import React, { Component, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { isNil } from 'ramda'
import moment from 'moment'
import styled from 'styled-components'
import { MsalContext } from "@azure/msal-react"
import { Form } from 'formsy-react'
import {
  Button,
  Colors,
  Display,
  GlobalStyles,
  Title1,
  Title2,
  TextInput,
} from 'advenio-components'
import { AuthRedux } from 'auth-advenio'
import ButtonMSAuth365  from './ButtonMSAuth365'
import { getPlatformLink, SENTRY_ENV,MSG_SUPPORT,DATE_SUPPORT, TIME_SUPPORT } from '../../config'
import ModalSupport from '../../shared/ModalSupport'

const AdvenioLogo = styled.img`
  width: 350px;
  margin-bottom: 32px;

  @media (max-width: 767px) {
    width: 100%;
  }
`
const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 15px;
  padding-right: 15px;
`
const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const Card = styled.div`
  ${GlobalStyles.borderRadius};
  width: 100%;
  margin-bottom: 20px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0,0,0, .1);

  @media (min-width: 768px) {
    min-width: 400px;
  }
`
const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px 0;
  ${({ newHeader }) => newHeader && `
    margin-bottom: 20px;
    padding: 0 0 0 0;
  `}
  @media (max-width: 767px) {
    padding: 16px 8px 0;
  }
`
const Heading = styled(Title2)`
  color: ${Colors.blueText};
`
const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;

  @media (max-width: 767px) {
    padding: 16px;
  }
`
const ErrorContainer = styled.div`
  ${GlobalStyles.borderRadius};
  padding: 16px;
  background-color: ${Colors.red100};
  border: 1px solid ${Colors.red300};
  margin-bottom: 15px;
`
const ErrorTitle = styled(Title1)`
  color: ${Colors.redText};
`
const SubHeading = styled(Title2)`
  color: ${Colors.red500};
  padding-left:2px;
`
const ErrorText = styled.p`
  display: block;
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 14px;
  color: ${Colors.redText};
`
const Forgot = styled.span`
  color: ${Colors.blue500};
  cursor: pointer;
`
const Banner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  color: ${Colors.yellowText};
  background-color: ${Colors.yellow300};
  margin-bottom: 15px;
`
const Img = styled.img`
  margin-right: 8px;
`
const MsgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 32px 15px 32px;
`
const MsgText = styled.p`
  color: ${Colors.gray700};
  margin-bottom: 16px;
`
class Login extends Component {

  static contextType = MsalContext

  onAuth = (data) => {
    const { email, password } = data

    if (isNil(email) || isNil(password)) return

    this.props.authUser(data)
  }

  componentWillReceiveProps(nextProps){
    const { loginError } = this.props
    if(loginError !== nextProps.loginError && nextProps.loginError !== ''){
      if(this.context.accounts.length > 0){
        this.context.instance.logoutPopup({
          postLogoutRedirectUri: "/",
          mainWindowRedirectUri:"/login"
        })
      }
    }
  }


  forgotPassword = () => this.props.goTo('/recover-password')

  render() {
    const { loginError, authUser, auth} = this.props
    return (
      <Container>
        <ContentWrapper>
       <AdvenioLogo src="assets/logo_MiAdvenio.svg" />
       <CardHeader newHeader>
              {/* <Heading>Iniciar sesión -</Heading> */}
              <SubHeading>MiAdvenio</SubHeading>
        </CardHeader>
        {loginError && (
          <ErrorContainer>
            <ErrorTitle>Error:</ErrorTitle>
            <ErrorText>{loginError}</ErrorText>
          </ErrorContainer>
        )}
        { SENTRY_ENV !== 'production' &&(
          <Card>
            <CardBody>
              <Form onValidSubmit={this.onAuth}>
                <TextInput
                  type="email"
                  id="email"
                  name="email"
                  label="Correo"
                />
                <TextInput
                  type="password"
                  id="password"
                  name="password"
                  label="Contraseña"
                />
                <Button type="submit" primary fullWidth>Ingresar</Button>
              </Form>
            </CardBody>
          </Card>
          )}
          {/* <button onClick={() => methodDoesNotExist()}>Break the world</button> */}
        <ButtonMSAuth365 LoginApi={authUser} auth={auth} loginError={loginError}/>
        </ContentWrapper>
        <ModalSupport
          show={moment(performance.now()).format('ss') < 7 && (MSG_SUPPORT === 'false'? false :true)}
          message={ <span> Le informamos que este próximo <b>{DATE_SUPPORT}</b>, se estará realizando un <b>mantenimiento preventivo</b> en un horario de <b> {TIME_SUPPORT} (UTC)</b>.</span>}
        />
      </Container>
    )
  }
}

Login.propTypes = {
  /** Login error message */
  loginError: PropTypes.string.isRequired,
  /** Attempt to authenticate the user via the API */
  authUser: PropTypes.func.isRequired,
  /** Navigate to the given URI */
  goTo: PropTypes.func.isRequired,
}

Login.defaultProps = {
  loginError: '',
  authUser: () => {},
}

const mapStateToProps = ({ auth }) => ({
  loginError: auth.error,
  auth: auth
})

const mapDispatchToProps = dispatch => ({
  authUser: data => dispatch(AuthRedux.Actions.loginRequest(data)),
  goTo: path => dispatch(push(path)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/Containers/Auth/Login.jsx